// external
import { region } from '../localizations/current-locale';
import { dynamicBrand } from '../utils/brand';

// internal
import { valid, invalid } from '../utils/validators/resolutions';

let messages;
import(`../utils/text-resources/${dynamicBrand()}/${region}/messages`).then((m) => {
  messages = m.default;
});

const employedToMonth = (input = '') => {
  if (input === '' || input == null) {
    return invalid(messages.employedToMonthIsRequired);
  }

  return valid();
};

export default employedToMonth;
